import * as React from 'react';
export const FaxGlyph = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("rect", { x: 14, y: 32, width: 34.94, height: 15.5, fill: "var(--color__glyph__accent)" }),
    React.createElement("path", { d: "M48.9397 32C43.2389 27.7147 40.1127 21.5147 38.8255 16.5H18.9648C20.2521 21.5147 23.3783 27.7147 29.0791 32H48.9397Z", fill: "var(--color__glyph__primary)" })));
